/**
 * Ephemeral prev/next navigation context for EmailDetail's J/K shortcuts.
 * The Emails list writes the ordered list of visible email IDs into sessionStorage,
 * EmailDetail reads it to know which email is before/after the current one.
 *
 * Why sessionStorage (not a context provider)?
 * - Survives full-page reloads & opening the detail in a new tab (expected behavior).
 * - Scoped to the tab — doesn't leak across windows.
 * - No global React plumbing needed.
 */
const KEY = "prism.email-nav-ids";

export function rememberEmailList(ids) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(ids));
  } catch { /* quota or disabled — silently ignore */ }
}

export function getNeighbors(currentId) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return { prev: null, next: null, index: -1, total: 0 };
    const ids = JSON.parse(raw);
    if (!Array.isArray(ids) || ids.length === 0) return { prev: null, next: null, index: -1, total: 0 };
    const i = ids.indexOf(currentId);
    return {
      prev: i > 0 ? ids[i - 1] : null,
      next: i >= 0 && i < ids.length - 1 ? ids[i + 1] : null,
      index: i,
      total: ids.length,
    };
  } catch {
    return { prev: null, next: null, index: -1, total: 0 };
  }
}
